import { ChangeEvent } from 'react';
import { Box, Select } from '@nimbus-ds/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { FormInput, FormSelect } from '../common';

interface ContactInfoSectionProps {
  country: string;
  phone: string;
  countries: Array<{ value: string; label: string }>;
  errors: {
    country?: string;
    phone?: string;
  };
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeSelect: (e: ChangeEvent<HTMLSelectElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  isCountriesLoading: boolean;
}

export function ContactInfoSection({
  country,
  phone,
  countries,
  errors,
  handleChange,
  handleChangeSelect,
  handleBlur,
  isCountriesLoading,
}: Readonly<ContactInfoSectionProps>) {
  const t = useTranslationConfigurations(
    'domains.checkout.registrationInfo.contactInfo',
  );

  return (
    <Box display="grid" gridTemplateColumns="1fr 1fr" gap="4">
      <FormSelect
        label={t('country')}
        id="country"
        name="country"
        value={country.toLowerCase()}
        onChange={handleChangeSelect}
        error={errors.country}
        isLoading={isCountriesLoading}
      >
        <Select.Option value="" label={t('countryPlaceholder')} />
        {countries.map((countryOption) => (
          <Select.Option
            key={countryOption.value}
            value={countryOption.value}
            label={countryOption.label}
          />
        ))}
      </FormSelect>

      <FormInput
        label={t('phone')}
        name="phone"
        type="number"
        value={phone}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.phone}
      />
    </Box>
  );
}
